import { __awaiter, __generator } from "tslib";
import { useEffect, useRef } from 'react';
import { logInDev, useAudio } from '../../../../foundation';
import { DIALER_PAD_PLUS } from './DialPadUtils';
/**
 * Custom hook that handles playing audio for key presses in a dial pad.
 *
 * @param audioOption - The audio options for configuring the hook.
 * @returns A function that plays the audio for a given key.
 */
export var useKeyAudio = function (_a) {
    var sounds = _a.sounds, processor = _a.processor;
    var audio = useAudio();
    var lastPlayRef = useRef();
    useEffect(function () {
        processor === null || processor === void 0 ? void 0 : processor(audio);
    }, [audio, processor]);
    var play = function (src) { return __awaiter(void 0, void 0, void 0, function () {
        var lastPlay;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lastPlay = lastPlayRef.current;
                    if (!lastPlay) return [3 /*break*/, 2];
                    return [4 /*yield*/, lastPlay];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    audio.currentTime = 0;
                    audio.src = src;
                    lastPlayRef.current = audio.play().catch(function (reason) {
                        if (process.env.NODE_ENV !== 'production') {
                            logInDev({ component: 'RcDialerPad', message: reason });
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var playKeyAudio = function (key) {
        if (!sounds)
            return false;
        var playTarget = key === DIALER_PAD_PLUS ? '0' : key;
        var sound = sounds[playTarget];
        if (sound) {
            return play(sound);
        }
        return false;
    };
    return playKeyAudio;
};
